<script setup lang="ts">
import { RouterView } from 'vue-router'
import Box from '@uiKit/elements/Box.vue'
import { AuthShowcase } from '@modules/auth'
import AuthFooter from './AuthFooter.vue'

// Pre-auth acquisition shell (sign-in, email, OTP verify, UAE Pass callback). A
// full-viewport split: the form column carries the routed screen with the legal
// footer pinned beneath it, and the photo showcase fills the other column edge
// to edge. Each screen owns its own header and card; this shell owns the split.
// Below 992px the showcase drops and the form column takes the full width.
</script>

<template>
  <Box is="main" class="signup-shell" block>
    <Box direction="col" class="signup-shell__form-column">
      <!-- Takes whatever the footer leaves, so the screen's own `height: 100%`
           resolves against the space above the strip rather than the column. -->
      <Box class="signup-shell__body">
        <RouterView />
      </Box>
      <AuthFooter />
    </Box>

    <Box is="aside" class="signup-shell__showcase">
      <AuthShowcase />
    </Box>
  </Box>
</template>

<style scoped>
.signup-shell {
  display: flex;
  height: 100dvh;
  overflow: hidden;
  background: var(--p-surface-50);
}

/* 781 / 731 at the 1512px frame. */
.signup-shell__form-column {
  flex: 1 1 52%;
  min-width: 0;
}

.signup-shell__body {
  flex: 1;
  min-height: 0;
}

.signup-shell__showcase {
  flex: 1 1 48%;
  min-width: 0;
}

@media (max-width: 992px) {
  .signup-shell {
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }

  .signup-shell__showcase {
    display: none;
  }
}
</style>
